(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentahoyrealtimeController', VentahoyrealtimeController);

    VentahoyrealtimeController.$inject = ['Ventahoyrealtime'];

    function VentahoyrealtimeController(Ventahoyrealtime) {

        var vm = this;

        vm.ventahoyrealtimes = [];

        loadAll();

        function loadAll() {
            Ventahoyrealtime.query(function(result) {
                vm.ventahoyrealtimes = result;
                vm.searchQuery = null;
            });
        }
    }
})();
